// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1g-7";
export var adjustableWidthBorderHeld = "_1g-8";
export var arrow = "_1g-3";
export var arrowButton = "_1g-4";
export var headerCell = "_1g-0";
export var help = "_1g-2";
export var icon = "_1g-1";
export var iconWrapper = "_1g-6";
export var noBorder = "_1g-b";
export var nonAdjustableWidthBorder = "_1g-9";
export var nonAdjustableWidthBorderHeld = "_1g-a";
export var textButton = "_1g-5";